import getContentItemType from 'utils/asset/getContentItemType';
import { getTeamIcon } from './getTeamIcon';
/*
 * By default, the name of asset icons should follow the
 * pattern `asset-${type}`, but we have a few exceptions
 * to this rule which are handled by the typeToIconMap object:
 */

var typeToIconMap = {
  asset: 'asset-default',
  msword: 'asset-text',
  playlist: 'playlist',
  search: 'search',
  team: 'team',
  user: 'user',
  topic: 'topic',
  section: 'section',
  web: 'asset-link',
  elearning: 'asset-fluidbook',
  assessment: 'asset-quiz',
  survey: 'asset-quiz',
  workshop: 'team',
  event: 'asset-event'
};

/*
 * If you need to get an icon from a context where you already
 * have access to the contentItem type, use the getContentItemIconFromType
 * function.
 *
 * Otherwise use `getAssetIcon` which will call getContentItemType for you
 */

export function getContentItemIconFromType(type) {
  return typeToIconMap[type] || "asset-".concat(type);
}
export function getAssetIcon(asset) {
  var includeCustomType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var type = getContentItemType(asset, includeCustomType);
  if (type === 'team') {
    return getTeamIcon(asset.isSmartTeam);
  }
  return getContentItemIconFromType(type);
}